type FirstMessageTypeContext = {
  viewerRole?: string | null;
  participantRole?: string | null;
  hasMessages: boolean;
};

/**
 * An advisor's first message to a provider must declare a contact type — the
 * backend rejects that send without one (spec ticket 08 §5.1).
 *
 * Sub-delegates are included because they may be acting inside an advisor's
 * workspace; the backend only enforces the type on a genuine advisor first
 * send, so an unnecessary selection is harmless while a missing one is a 400.
 */
export const requiresFirstMessageType = ({
  viewerRole,
  participantRole,
  hasMessages,
}: FirstMessageTypeContext): boolean =>
  !hasMessages
  && participantRole === 'SERVICE_PROVIDER'
  && (viewerRole === 'FINANCIAL_ADVISOR' || viewerRole === 'SUB_DELEGATE');

/**
 * Feature 102: an SP sender picks a subject before the first message of a
 * conversation, whatever the recipient's role. First-message-per-conversation
 * only — prompting on every message would be noisy. The backend treats
 * `spMessageSubject` as optional, so a missed prompt never turns into a 400.
 */
export const requiresSpMessageSubject = ({
  viewerRole,
  hasMessages,
}: Pick<FirstMessageTypeContext, 'viewerRole' | 'hasMessages'>): boolean =>
  !hasMessages && viewerRole === 'SERVICE_PROVIDER';
